<template>
<form id="addressUpdateForm" method="post">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Update User Session Data</h5>

            <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
          </div>
          <div class="modal-body">

            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.usersuid.$errors.length }">
                            <label class="form-label">UID</label>
                            <input type="text" class="form-control form-control-lg" name="usersuid" disabled v-model="v$.form.usersuid.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.usersuid.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.subscription.$errors.length }">
                            <label class="form-label">Subscription</label>
                            <input type="text" class="form-control form-control-lg" name="subscription" v-model="v$.form.subscription.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.subscription.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.status.$errors.length }">
                            <label class="form-label">Status</label>
                            <input type="text" class="form-control form-control-lg" name="status" v-model="v$.form.status.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.status.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.current_start.$errors.length }">
                            <label class="form-label">Start Date</label>
                            <input type="text" class="form-control form-control-lg" name="current_start" v-model="v$.form.current_start.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.current_start.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.current_expire.$errors.length }">
                            <label class="form-label">Current Expiration</label>
                            <input type="text" class="form-control form-control-lg" name="current_expire" v-model="v$.form.current_expire.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.current_expire.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.remaining_dataset.$errors.length }">
                            <label class="form-label">Remaining Datasets</label>
                            <input type="text" class="form-control form-control-lg" name="remaining_dataset" v-model="v$.form.remaining_dataset.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.remaining_dataset.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.remaining_prospect.$errors.length }">
                            <label class="form-label">Remaining Prospects</label>
                            <input type="text" class="form-control form-control-lg" name="remaining_prospect" v-model="v$.form.remaining_prospect.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.remaining_prospect.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" :class="{ error: v$.form.email.$errors.length }">
                            <label class="form-label">Remaining Email Prospects</label>
                            <input type="text" class="form-control form-control-lg" name="email" v-model="v$.form.email.$model" />
                            <div class="input-errors" v-for="(error, index) of v$.form.email.$errors" :key="index">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- div class="col-12">
                        <div class="form-group">
                          <input class="form-check-input me-2" type="checkbox" id="zcataccess" name="zcataccess" :checked="zcataccess" @click="toggleZCATState()">
                          <label class="form-check-label" for="zcataccess">Full ZCAT Access</label>
                        </div>
                    </div -->
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
            <button type="button" class="btn btn-primary" @click="onSubmit" :disabled="v$.form.$invalid">Update</button>
          </div>
        </div>
      </form>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import axios from 'axios';
export default {
  name: 'ModalEditUsersSession',
  setup () {
    return {
        v$: useVuelidate()
    }
  },
  data () {
    return {
      form: {
        status: this.passedModalData.status,
        current_expire: this.passedModalData.current_expire,
        current_start: this.passedModalData.current_start,
        remaining_prospect: this.passedModalData.remaining_prospect,
        remaining_dataset: this.passedModalData.remaining_dataset,
        email: this.passedModalData.email,
        usersuid: this.passedModalData.uid,
        subscription: this.passedModalData.subscription,
      },
      //zcataccess: false
    }
  },
  props: {
    passedModalData: ''
  },
  validations () {
    return {
        form: {
            status: { required },
            current_expire: { },
            current_start: { },
            remaining_prospect: { },
            remaining_dataset: { },
            email: { },
            usersuid: { },
            subscription: { }

        }
    }
  },
  props: {
    passedModalData: []
  },
  methods: {
   
    onSubmit() {
      axios.get('/update_user_session', { params: {uid: this.form.usersuid, status: this.form.status, current_expire: this.form.current_expire, current_start: this.form.current_start, remaining_prospect: this.form.remaining_prospect, remaining_dataset: this.form.remaining_dataset, email: this.form.email, subscription: this.form.subscription}}) 
      .then(
			(response) => {
        console.log('update_user_response: '+response.data);
        this.$emit('customChange', {shell: 'UserList', dataset: ''});
        // this.$emit('lookupUserInfo');
        this.$emit('closeModal');
      })
      .catch(
			(error) => {
        console.log(error);
        console.log('form submit failed');
      });
    }
  },
  mounted() {
      console.log(JSON.stringify(this.passedModalData));
      if(this.passedModalData.email) {
        console.log('email exists'+this.passedModalData.email);
      } else {
        console.log('there is no email');
      };
      //this.checkZCAT('zcat');
      //this.checkZCAT('dedupe');
  },
}
</script>